import { args } from '../../../common/args';
export const onMeetingLinkEmptyStateEligibilityResponse = {
  onMeetingLinkEmptyStateEligibilityResponse: {
    args: {
      shouldShowEmptyState: args.bool()
    }
  }
};